import React from 'react'
import Specialities from './Specialities'
import Hero from './Hero'
import Topproperties from './Topproperties'
import Value from './Value'
import Footer from './Footer'
import Latestnews from './Latestnews'

function Home() {
  return (
   <>
   <Hero/>
   <Latestnews/>
   <Topproperties/>
   <Specialities/>
   <Value/>
   <Footer/>
   </>
  )
}

export default Home
